// Decode claims for display only; signature verification belongs on the server.
export const parseJwtPayload = <T = unknown>(token: string): T => {
  const [, payload] = token.split('.');
  const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
  const bytes = atob(base64);

  // atob returns bytes, not UTF-8 text. Decode before parsing Unicode claims.
  const json = decodeURIComponent(
    Array.from(bytes, (byte) => `%${byte.charCodeAt(0).toString(16).padStart(2, '0')}`).join('')
  );
  return JSON.parse(json);
};
